import React from "react";
import { useSearchParams, Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "../../components/SEO";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const { t } = useTranslation();
  
  const sessionId = searchParams.get("session_id");
  const programTitle = searchParams.get("program_title");
  const type = searchParams.get("type");
  const courseTitle = searchParams.get("course_title");
  const isCourse = type === "course";

  return (
    <>
      <SEO 
        title={`${t("paymentPages.successTitle")} - Internationale in Kunst`}
        description={t("paymentPages.successMessage")}
        noindex
      />
      
      <div className="min-h-screen bg-black text-white flex items-center justify-center px-4">
        <div className="max-w-md w-full bg-gradient-to-b from-black/70 via-zinc-900/80 to-zinc-800/90 rounded-2xl p-8 shadow-2xl border border-white/20 text-center">
          <div className="text-6xl mb-6">🎉</div>
          <h1 className="text-3xl font-bold mb-4">{t("paymentPages.successTitle")}</h1>
          <p className="text-gray-300 mb-6">
            {isCourse ? t("paymentPages.courseSuccessMessage") : t("paymentPages.successMessage")}
            {isCourse && courseTitle && (
              <span className="block mt-2">
                <strong>{courseTitle}</strong>
              </span>
            )}
            {!isCourse && programTitle && (
              <span className="block mt-2">
                <strong>{programTitle}</strong> {t("paymentPages.ticketInfo")}
              </span>
            )}
          </p>
          
          <div className="space-y-3">
            <Link
              to="/"
              className="block w-full bg-[#D8001D] hover:bg-[#B8001A] text-white py-3 px-6 rounded font-semibold transition-colors"
            >
              {t("paymentPages.backToHome")}
            </Link>
          </div>
        </div>
      </div>


    </>
  );
};

export default PaymentSuccess; 